import { createContext, useReducer, useEffect } from "react";

export const AuthContext = createContext();

export const authReducer = (state, action) => {
  switch (action.type) {
    case "LOGIN":
      return { user: action.payload };
    case "LOGOUT":
      return { user: null };
    case "SUBMIT_COMP":
      localStorage.setItem(
        "user",
        JSON.stringify({ ...state.user, compForm: true })
      );
      return { user: { ...state.user, compForm: true } };
    case "SUBMIT_CAMP":
      localStorage.setItem(
        "user",
        JSON.stringify({ ...state.user, campForm: true })
      );
      return { user: { ...state.user, campForm: true } };
    case "SUBMIT_PAYMENT":
      localStorage.setItem(
        "user",
        JSON.stringify({ ...state.user, payment: true })
      );
      return { user: { ...state.user, payment: true } };
    case "UNSUBMIT_PAYMENT":
      localStorage.setItem(
        "user",
        JSON.stringify({ ...state.user, payment: false })
      );
      return { user: { ...state.user, payment: false } };
    default:
      return state;
  }
};

export const AuthContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(authReducer, {
    user: null,
  });

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user")); // the local storage is a json, we are making it into an object
    if (user) {
      dispatch({ type: "LOGIN", payload: user });
    }
  }, []); // firing a function when the component renders

  console.log("AuthContext state: ", state);

  return (
    <AuthContext.Provider value={{ ...state, dispatch }}>
      {children}
    </AuthContext.Provider>
  );
};
